export { default } from './logo';
export { default as Horizontal } from './Horisontal standard.svg';
export { default as EnglishHorizontal } from './Horisontal standard engelsk.svg';
export { default as KommuneVaapen } from './Trondheim kommunevåpen.svg';
export { default as HorizontalPNG } from './Horisontal standard.png';
export { default as EnglishHorizontalJPG } from './Horisontal standard engelsk.jpg';
export { default as HorizontalWhite } from './Horisontal standard hvit.png';
